/**
 * Wave 7 / Lot B — aucune troncature MUETTE.
 *
 * Les listes du portail sont plafonnées côté API (100 factures, 100 BL, 100
 * avoirs, 100 contrats, 50 commandes, 200 lots, 300 produits). Rien ne le disait :
 * un client à 140 factures voyait ses 100 dernières et pouvait croire que les
 * autres avaient disparu. Quand la liste touche son plafond, on le dit et on
 * indique où trouver le reste.
 */
interface Props {
  /** Nombre de lignes réellement reçues. */
  shown: number;
  /** Plafond appliqué par l'API pour cette liste. */
  cap: number;
  /** Nom de ce qu'on compte, au pluriel : « factures ». */
  label: string;
  /** Genre du nom, pour l'accord — « les plus récentes » / « les plus récents ». */
  genre?: "m" | "f";
}

export function ListCapNotice({ shown, cap, label, genre = "f" }: Props) {
  if (shown < cap) return null;
  return (
    <p className="mt-3 text-xs text-muted">
      {genre === "f"
        ? `Seules les ${cap} ${label} les plus récentes sont affichées.`
        : `Seuls les ${cap} ${label} les plus récents sont affichés.`}{" "}
      Pour les plus anciennes, demandez-les à votre fournisseur.
    </p>
  );
}
